module.exports = __webpack_public_path__ + "img/DAVID_CANNON_19-rs.868d1b44.jpg";